import React, { Component } from 'react';
import './ChallengeStatement.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import jsPDF from 'jspdf';
import rasterizeHTML from 'rasterizehtml';

class ChallengeStatementSuccess extends Component {
    constructor(props) {
        super(props);
        this.defaultParams = {};
        this.state = {
            pdfDownload: false,
        };
    }

    printDocument = (e) => {
        e.preventDefault();
        const canvas = document.createElement('canvas');
        canvas.height = 1000;
        canvas.width = 1500;

        const { category, company, goal, statement, timeframe } = this.props.getChallengeStatementData.Items[0].chalange.horizon1;
        const horizon2Data = this.props.getChallengeStatementData.Items[0].chalange.horizon2;
        let html = `<div style='width:"1000px";padding: 20px 0px 0px 30px'>
                        <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Challenge Statements</h2>
                        <p style="color: #333333; font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-style: italic; margin: 2px 0px 0px 0px">Results</p>
                        <br/>
                        <div style="margin-bottom: 20px">
                                        <div>
                                            <div style='width: fit-content;    padding: 10px; margin-bottom: 15px; background: #f2f2f2;margin-left: 10px;'>
                                                <a style="font-weight: bold; text-shadow: 0px 0px 3px #ddd; color: #000">Challenge Statement Horizon 1</a>
                                            </div>
                                        </div>
                                        <div style="width: 700px">
                                            <table style="width: 100%" border="1" cellspacing="0" cellpadding="15">
                                                <tbody>
                                                    <tr>
                                                        <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">How Can ...</td>
                                                        <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px;">${company}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">achieve ...</td>
                                                        <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px;">${goal}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">in ...</td>
                                                        <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px;">${category}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">over the next ...</td>
                                                        <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px;">${timeframe} ${statement}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                    </div>`;

        if(horizon2Data){
            html += `<div style='width:"1000px";padding: 20px 0px 0px 30px'>
            <div style="margin-bottom: 20px">
            <div>
                <div style='width: fit-content;    padding: 10px; margin-bottom: 15px; background: #f2f2f2;margin-left: 10px;'>
                    <a style="font-weight: bold; text-shadow: 0px 0px 3px #ddd; color: #000">Challenge Statement Horizon 2</a>
                </div>
            </div>
            <div style="width: 700px">
                <table style="width: 100%" border="1" cellspacing="0" cellpadding="15">
                    <tbody>
                        <tr>
                            <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">How Can ...</td>
                            <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">${horizon2Data.company?horizon2Data.company:company}</td>
                        </tr>
                        <tr>
                            <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">achieve ...</td>
                            <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">${horizon2Data.goal}</td>
                        </tr>
                        <tr>
                            <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">in ...</td>
                            <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">${horizon2Data.category}</td>
                        </tr>
                        <tr>
                            <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">over the next ...</td>
                            <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">${horizon2Data.timeframe} ${horizon2Data.statement}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </div>
            `
        }
        rasterizeHTML.drawHTML(html, canvas).then((renderResult) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'pt', 'a4');
            pdf.addImage(imgData, 'JPEG', 0, 0);
            pdf.save('challenge_statment.pdf');
        });
    }

    printPage = () => {
        const { category, company, goal, timeframe } = this.props.getChallengeStatementData.Items[0].chalange.horizon1;
        const horizon2Data = this.props.getChallengeStatementData.Items[0].chalange.horizon2;
        let html = `<div style='width:"1000px";padding: 20px 0px 0px 30px'>
                        <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Challenge Statements</h2>
                        <p style="color: #333333; font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-style: italic; margin: 2px 0px 0px 0px">Results</p>
                        <br/>
                        <div style="margin-bottom: 20px">
                                        <div>
                                            <div style='width: fit-content;    padding: 10px; margin-bottom: 15px; background: #f2f2f2;margin-left: 10px;'>
                                                <a style="font-weight: bold; text-shadow: 0px 0px 3px #ddd; color: #000">Challenge Statement Horizon 1</a>
                                            </div>
                                        </div>
                                        <div style="width: 700px">
                                            <table style="width: 100%" border="1" cellspacing="0" cellpadding="15">
                                                <tbody>
                                                    <tr>
                                                        <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">How can ...</td>
                                                        <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">${company}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">achieve ...</td>
                                                        <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">${goal}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">in ...</td>
                                                        <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">${category}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">over the next ...</td>
                                                        <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">${timeframe}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                    </div>`;

        if(horizon2Data){
            html += `<div style='width:"1000px";padding: 20px 0px 0px 30px'>
            <div style="margin-bottom: 20px">
            <div>
                <div style='width: fit-content;    padding: 10px; margin-bottom: 15px; background: #f2f2f2;margin-left: 10px;'>
                    <a style="font-weight: bold; text-shadow: 0px 0px 3px #ddd; color: #000">Challenge Statement Horizon 2</a>
                </div>
            </div>
            <div style="width: 700px">
                <table style="width: 100%" border="1" cellspacing="0" cellpadding="15">
                    <tbody>
                        <tr>
                            <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">How can ...</td>
                            <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">${horizon2Data.company?horizon2Data.company:company}</td>
                        </tr>
                        <tr>
                            <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">achieve ...</td>
                            <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">${horizon2Data.goal}</td>
                        </tr>
                        <tr>
                            <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">in ...</td>
                            <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">${horizon2Data.category}</td>
                        </tr>
                        <tr>
                            <td style="width: 15%; font-size: 13px; font-weight: bold; text-align: right;">over the next ...</td>
                            <td style="width: 85%; border: 1px solid #ddd; border-radius: 5px">${horizon2Data.timeframe}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </div>
            `
        }
        let w=window.open();
        w.document.write(html);
        w.print();
        w.close();
    };

    downloadPDF = (e) => {
        this.printDocument(e);
    }

    render() {
        const horizon1Data = this.props.editChallengeStatementData.data.horizon1;
        const horizon2Data = this.props.editChallengeStatementData.data.horizon2;

        return (
            <div className='projects-content challenge-statement-content'>
                <div className='step-bar'>
                    <div className='step step-two arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-two arrow-step active-step'>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className='row' >
                        <div className="col-md-12">
                            <h5 style={{ marginBottom: "0px" }}>BUSINESS CHALLENGE STATEMENT</h5>
                            <p><i>Results</i></p>
                        </div>
                        {horizon1Data &&
                            <div className='col-sm-6'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <h5>Challenge Statement Horizon 1</h5>
                                    </div>
                                    <div className='card-body'>
                                        <ul className='success-data-list'>
                                            <li><strong> How can ... </strong> {horizon1Data.company} </li>
                                            <li><strong> achieve ... </strong> {horizon1Data.goal} </li>
                                            <li><strong> in ... </strong> {horizon1Data.category} </li>
                                            <li><strong> over the next ... </strong> {horizon1Data.timeframe} </li>
                                            <li>{horizon1Data.statement} </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }
                        {horizon2Data &&
                            <div className='col-sm-6'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <h5>Challenge Statement Horizon 2 (Optional)</h5>
                                    </div>
                                    <div className='card-body'>
                                        <ul className='success-data-list'>
                                            <li><strong> How can ... </strong> {horizon1Data.company} </li>
                                            <li><strong> achieve ... </strong> {horizon2Data.goal} </li>
                                            <li><strong> in ... </strong> {horizon2Data.category} </li>
                                            <li><strong> over the next ... </strong> {horizon2Data.timeframe} </li>
                                            <li>{horizon2Data.statement} </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <Link className='btn btn-success' to={'/influencer-map/'+this.props.projectId}> Next </Link>
                                    <Link className='btn btn-success' to='/toolkit'> Done </Link>
                                    <div className='btn empty-btn default' onClick={this.downloadPDF}> Save PDF</div>
                                    <div className='btn empty-btn default' onClick={this.printPage}>Print</div>
                                    <div className='btn empty-btn default' onClick={this.props.backButton}> Back </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default (ChallengeStatementSuccess);



// WEBPACK FOOTER //
// ./src/components/ChallengeStatement/ChallengeStatementSuccess.jsx